export const EMAIL = "info@lunghefrequenze.com";
export const BLOG_URL = "https://homelf.lunghefrequenze.com/blog";

export const IMG = {
  outdoor: "/img/a.webp",
  europa: "/img/b.webp",
  viaggio: "/img/c.webp",
  giovani: "/img/d.webp",
};

export const INSTAGRAM_URL = "https://www.instagram.com/lunghefrequenze/";

export const NAV = ["/", "/chi-siamo", "/cosa-facciamo", "/progetti", "/contatti"];

export const AREA_IMG = { erasmus: "/img/b.webp", formazione: "/img/d.webp", outdoor: "/img/a.webp", inclusione: "/img/c.webp" };

